import { Result } from "antd";
import type { GisImportBatchData } from "../gisApi";

/**
 * Kết quả nạp — tách khỏi `GisImportReview` vì đây là kết cục của một QUYẾT ĐỊNH,
 * không phải nội dung đối soát.
 *
 * `PARTIAL_COMMIT` là trạng thái backend có thật (`GisImportCommitService.java:37,82-83,99`):
 * lượt nạp ghi được một phần, cán bộ bấm lại thì lượt sau chỉ xử lý dòng chưa ghi. Vì vậy nó
 * phải hiện như CẢNH BÁO kèm đường nạp nốt — không được đội lốt thành công trọn vẹn.
 *
 * Nút hành động nằm ở thanh đáy màn (`.gis-import-footer`), không lặp lại ở đây.
 */
export type GisImportCommitResultProps = Readonly<{
  batch: GisImportBatchData;
}>;

export function GisImportCommitResult({
  batch,
}: GisImportCommitResultProps): React.JSX.Element {
  if (batch.status === "PARTIAL_COMMIT") {
    const remaining = Math.max((batch.validRows ?? 0) - (batch.committedRows ?? 0), 0);
    return (
      <Result
        status="warning"
        title="Đã nạp một phần"
        subTitle={`Còn ${remaining} dòng chưa ghi. Lượt nạp lại chỉ xử lý những dòng còn thiếu, không ghi trùng.`}
      />
    );
  }

  return (
    <Result
      status="success"
      title={`Đã nạp ${batch.committedRows ?? 0} vị trí`}
      subTitle="Các dòng hợp lệ đã vào sơ đồ nghĩa trang. Dòng bị cách ly vẫn nằm nguyên trong tệp nguồn."
    />
  );
}
